import React, { useState } from 'react';
import Icon from '../AppIcon';
import Input from './Input';
import Button from './Button';
import { formService } from '../../services/formService';

const NewsletterSubscription = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);

    try {
      await formService?.submitNewsletterForm(email);
      setSuccess(true);
      setEmail('');

      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    } catch (err) {
      setError(err?.message || 'Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="newsletter-container">
        <div className="newsletter-success">
          <Icon name="CheckCircle2" size={24} color="var(--color-success)" />
          <div>
            <div className="font-semibold">Successfully subscribed!</div>
            <div className="text-sm">Check your inbox for confirmation.</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="newsletter-container">
      <div className="newsletter-header">
        <h3 className="newsletter-title">Stay Updated</h3>
        <p className="newsletter-description">
          Get the latest insights on IT engineering, entrepreneurship, and creative direction delivered to your inbox.
        </p>
      </div>
      <form onSubmit={handleSubmit} className="newsletter-form">
        <Input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e?.target?.value)}
          error={error}
          disabled={loading}
          className="flex-1"
        />
        <Button
          type="submit"
          variant="default"
          loading={loading}
          iconName="Send"
          iconPosition="right"
          className="sm:w-auto w-full"
        >
          Subscribe
        </Button>
      </form>
      <p className="text-xs text-muted-foreground text-center mt-4">
        Join 2,500+ professionals. Unsubscribe anytime.
      </p>
    </div>
  );
};

export default NewsletterSubscription;